module.exports = __webpack_public_path__ + "1f8ebf04e3bc680d21f1752c1b83def3.svg";